        <div *ngIf="(selectedNode && selectedNode.data.fields.length > 0)">
            <span id="mirror" style="visibility:hidden; white-space:pre;"></span>
            <formly-form [form]="selectedNode.data.form" 
                         [fields]="selectedNode.data.fields" 
                         [model]="selectedNode.data.model"
                         [selectedNode]="selectedNode"
                         (modelChange)="onModelChange($event)">
            </formly-form>
        </div>    
